import React from 'react';

import Loading from 'components/Loading';
import { SpinnerContainer } from './Loader.syle';

const Loader = () => (
  <SpinnerContainer>
    <Loading size={80} color="#bbb" ariaLabel="Loading summary" />
  </SpinnerContainer>
);

export default Loader;
